// extracted by mini-css-extract-plugin
module.exports = {"wrapperNoHeader":"imprint-module--wrapperNoHeader--3zBCq"};